// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-main {
  width: 100%;
}

.basic-contact {
  margin-left: 5%;
  margin-right: 5%;
}

.contact-heading-div {
  display: flex;
}

.blog-heading-div {
  display: flex;
}

.address-heading-div {
  display: flex;
  margin-top: 80px;
}

.blog-heading-div>* {
  flex: 1 1;
}

.contact-heading-div>* {
  flex: 1 1;
}

.address-heading-div>* {
  flex: 1 1;
}

.contact-heading-img-div {
  margin-left: 13%;
  margin-bottom: 8%;
  margin-top: 4%;
}

.profile-pic {
  box-shadow: 0 5px 15px #353535;
  border-radius: 4px;
}

.blog-heading-img-div {
  align-items: center;
  justify-content: center;
}

.contact-heading-text-div {
  text-align: center;
}

.blog-heading-text-div {
  text-align: center;
}

.address-heading-text-div {
  text-align: center;
}

.contact-heading-img-div>* {
  max-width: 100%;
  height: auto;
}

.blog-heading-img-div>* {
  max-width: 100%;
  height: auto;
}

.contact-heading-text {
  font-size: 56px;
  font-weight: 400;
  font-family: "Be Vietnam Pro", sans-serif;
  line-height: 1.1;
  text-align: center;
  margin-top: 60px;
}

.blog-heading-text {
  font-size: 56px;
  font-weight: 400;
  font-family: "Be Vietnam Pro", sans-serif;
  line-height: 1.1;
  text-align: center;
  margin-top: 40px;
}

.address-heading-text {
  font-size: 30px;
  font-family: "Be Vietnam Pro", sans-serif;
  text-align: center;
  margin-bottom: 10px;
}

.contact-header-detail-text {
  font-size: 20px;
  line-height: 30px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  font-family: "Be Vietnam Pro", sans-serif;
}

.blog-header-detail-text {
  font-size: 20px;
  line-height: 30px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  font-family: "Be Vietnam Pro", sans-serif;
}

.general-btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.blogsite-btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.address-btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0;
}

.general-btn {
  text-decoration: none;
  color: rgba(255, 255, 255, 1);
  padding: 15px 15px;
  margin-top: 25px;
  border-radius: 4px;
  border-width: 0px;
  width: 200px;
  height: 50px;
  font-weight: bold;
  font-family: "Google Sans Regular";
  font-size: 17px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

@media (max-width: 1380px) {
  .contact-heading-text {
    font-size: 50px;
    margin-top: 60px;
  }

  .blog-heading-text {
    font-size: 50px;
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .contact-heading-text {
    font-size: 30px;
    margin-top: 0px;
  }

  .blog-heading-text {
    font-size: 30px;
    margin-top: 0px;
  }

  .contact-heading-img-div {
    margin-left: auto;
    margin-right: auto;
  }

  .address-heading-text {
    font-size: 20px;
  }

  .blog-heading-div {
    flex-direction: column-reverse;
    margin-top: 60px;
  }

  .address-heading-div {
    flex-direction: column;
    margin-top: 60px;
  }

  .blog-heading-text-div {
    margin-top: 40px;
  }

  .address-heading-text-div {
    margin-top: 40px;
  }

  .contact-heading-div {
    flex-direction: column;
  }

  .contact-header-detail-text {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 0px;
    line-height: normal;
    text-align: center;
  }

  .blog-header-detail-text {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 0px;
    line-height: normal;
    text-align: center;
  }
}

/* Custom Slider Container */
.unlock-container {
  margin-top: 30px;
  position: relative;
  width: 300px;
  height: 60px;
  margin-left: auto;
  margin-right: auto;
}

/* Invisible Input on top */
.unlock-slider-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  cursor: grab;
  margin: 0;
}

.unlock-slider-input:active {
  cursor: grabbing;
}

/* Visual Track */
.custom-slider-track {
  position: absolute;
  top: 10px;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  overflow: visible;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.2);
}

.track-fill {
  height: 100%;
  background: var(--accent-color, #4facfe);
  border-radius: 20px;
  opacity: 0.3;
  pointer-events: none;
}

.track-destination {
  position: absolute;
  right: 15px;
  font-size: 24px;
  z-index: 1;
  pointer-events: none;
  animation: bounce 2s infinite;
}

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

.custom-thumb {
  position: absolute;
  top: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transform: translateY(-50%) rotate(90deg);
  pointer-events: none;
  transition: transform 0.1s;
  z-index: 5;
}

.unlock-slider-input:active+.custom-slider-track .custom-thumb {
  transform: translateY(-50%) rotate(90deg) scale(1.1);
}

.slide-text {
  position: absolute;
  width: 100%;
  text-align: center;
  pointer-events: none;
  font-family: "Google Sans Regular";
  font-size: 14px;
  color: inherit;
  opacity: 0.8;
  font-weight: 500;
  z-index: 2;
  padding-left: 20px;
}

.unlock-slider {
  -webkit-appearance: none;
  width: 100%;
  max-width: 300px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  outline: none;
  overflow: hidden;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  cursor: grab;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.unlock-slider:active {
  cursor: grabbing;
}

.unlock-slider::-webkit-slider-thumb {
  appearance: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  cursor: grab;
  /* Use box-shadow to fill the track behind the thumb */
  box-shadow: -407px 0 0 400px var(--accent-color, #4facfe);
  border: 2px solid rgba(0, 0, 0, 0.1);
  -webkit-transition: transform 0.1s;
  transition: transform 0.1s;
}

.unlock-slider::-moz-range-thumb {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  cursor: grab;
  box-shadow: -407px 0 0 400px var(--accent-color, #4facfe);
  border: 2px solid rgba(0, 0, 0, 0.1);
}

.unlock-message {
  font-family: "Google Sans Regular";
  font-size: 16px;
  color: inherit;
  opacity: 0.9;
  font-weight: 500;
  animation: pulse-text 2s infinite;
}

@keyframes pulse-text {

  0%,
  100% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }
}

.unlocked-btn-container {
  animation: pop-in 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop-in {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/contact/ContactComponent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,oBAAoB;EACpB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sDAAsD;EACtD,yDAAyD;EACzD,oCAAoC;EACpC,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".contact-main {\n  width: 100%;\n}\n\n.basic-contact {\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.contact-heading-div {\n  display: flex;\n}\n\n.blog-heading-div {\n  display: flex;\n}\n\n.address-heading-div {\n  display: flex;\n  margin-top: 80px;\n}\n\n.blog-heading-div>* {\n  flex: 1;\n}\n\n.contact-heading-div>* {\n  flex: 1;\n}\n\n.address-heading-div>* {\n  flex: 1;\n}\n\n.contact-heading-img-div {\n  margin-left: 13%;\n  margin-bottom: 8%;\n  margin-top: 4%;\n}\n\n.profile-pic {\n  box-shadow: 0 5px 15px #353535;\n  border-radius: 4px;\n}\n\n.blog-heading-img-div {\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-heading-text-div {\n  text-align: center;\n}\n\n.blog-heading-text-div {\n  text-align: center;\n}\n\n.address-heading-text-div {\n  text-align: center;\n}\n\n.contact-heading-img-div>* {\n  max-width: 100%;\n  height: auto;\n}\n\n.blog-heading-img-div>* {\n  max-width: 100%;\n  height: auto;\n}\n\n.contact-heading-text {\n  font-size: 56px;\n  font-weight: 400;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  line-height: 1.1;\n  text-align: center;\n  margin-top: 60px;\n}\n\n.blog-heading-text {\n  font-size: 56px;\n  font-weight: 400;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  line-height: 1.1;\n  text-align: center;\n  margin-top: 40px;\n}\n\n.address-heading-text {\n  font-size: 30px;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.contact-header-detail-text {\n  font-size: 20px;\n  line-height: 30px;\n  margin-top: 0px;\n  margin-left: 20px;\n  margin-right: 20px;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n}\n\n.blog-header-detail-text {\n  font-size: 20px;\n  line-height: 30px;\n  margin-top: 0px;\n  margin-left: 20px;\n  margin-right: 20px;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n}\n\n.general-btn-div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.blogsite-btn-div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.address-btn-div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 0;\n}\n\n.general-btn {\n  text-decoration: none;\n  color: rgba(255, 255, 255, 1);\n  padding: 15px 15px;\n  margin-top: 25px;\n  border-radius: 4px;\n  border-width: 0px;\n  width: 200px;\n  height: 50px;\n  font-weight: bold;\n  font-family: \"Google Sans Regular\";\n  font-size: 17px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n@media (max-width: 1380px) {\n  .contact-heading-text {\n    font-size: 50px;\n    margin-top: 60px;\n  }\n\n  .blog-heading-text {\n    font-size: 50px;\n    margin-top: 40px;\n  }\n}\n\n@media (max-width: 768px) {\n  .contact-heading-text {\n    font-size: 30px;\n    margin-top: 0px;\n  }\n\n  .blog-heading-text {\n    font-size: 30px;\n    margin-top: 0px;\n  }\n\n  .contact-heading-img-div {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .address-heading-text {\n    font-size: 20px;\n  }\n\n  .blog-heading-div {\n    flex-direction: column-reverse;\n    margin-top: 60px;\n  }\n\n  .address-heading-div {\n    flex-direction: column;\n    margin-top: 60px;\n  }\n\n  .blog-heading-text-div {\n    margin-top: 40px;\n  }\n\n  .address-heading-text-div {\n    margin-top: 40px;\n  }\n\n  .contact-heading-div {\n    flex-direction: column;\n  }\n\n  .contact-header-detail-text {\n    font-size: 16px;\n    margin-left: 0px;\n    margin-right: 0px;\n    line-height: normal;\n    text-align: center;\n  }\n\n  .blog-header-detail-text {\n    font-size: 16px;\n    margin-left: 0px;\n    margin-right: 0px;\n    line-height: normal;\n    text-align: center;\n  }\n}\n\n/* Custom Slider Container */\n.unlock-container {\n  margin-top: 30px;\n  position: relative;\n  width: 300px;\n  height: 60px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Invisible Input on top */\n.unlock-slider-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 10;\n  cursor: grab;\n  margin: 0;\n}\n\n.unlock-slider-input:active {\n  cursor: grabbing;\n}\n\n/* Visual Track */\n.custom-slider-track {\n  position: absolute;\n  top: 10px;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  overflow: visible;\n  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.track-fill {\n  height: 100%;\n  background: var(--accent-color, #4facfe);\n  border-radius: 20px;\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.track-destination {\n  position: absolute;\n  right: 15px;\n  font-size: 24px;\n  z-index: 1;\n  pointer-events: none;\n  animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n.custom-thumb {\n  position: absolute;\n  top: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  transform: translateY(-50%) rotate(90deg);\n  pointer-events: none;\n  transition: transform 0.1s;\n  z-index: 5;\n}\n\n.unlock-slider-input:active+.custom-slider-track .custom-thumb {\n  transform: translateY(-50%) rotate(90deg) scale(1.1);\n}\n\n.slide-text {\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  pointer-events: none;\n  font-family: \"Google Sans Regular\";\n  font-size: 14px;\n  color: inherit;\n  opacity: 0.8;\n  font-weight: 500;\n  z-index: 2;\n  padding-left: 20px;\n}\n\n.unlock-slider {\n  -webkit-appearance: none;\n  width: 100%;\n  max-width: 300px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 25px;\n  outline: none;\n  overflow: hidden;\n  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n  cursor: grab;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n}\n\n.unlock-slider:active {\n  cursor: grabbing;\n}\n\n.unlock-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: grab;\n  /* Use box-shadow to fill the track behind the thumb */\n  box-shadow: -407px 0 0 400px var(--accent-color, #4facfe);\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  transition: transform 0.1s;\n}\n\n.unlock-slider::-moz-range-thumb {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #fff;\n  cursor: grab;\n  box-shadow: -407px 0 0 400px var(--accent-color, #4facfe);\n  border: 2px solid rgba(0, 0, 0, 0.1);\n}\n\n.unlock-message {\n  font-family: \"Google Sans Regular\";\n  font-size: 16px;\n  color: inherit;\n  opacity: 0.9;\n  font-weight: 500;\n  animation: pulse-text 2s infinite;\n}\n\n@keyframes pulse-text {\n\n  0%,\n  100% {\n    opacity: 0.6;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n.unlocked-btn-container {\n  animation: pop-in 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n@keyframes pop-in {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
